export default {
  common: {
    adminFunction: "Administrator function",
    ecatLibrary: "e-CAT Library",
    accountManagement: "Account management",
    accountPermission: "Management account & permission",
    regionManagement: "Region management",
    zoneCountryCity: "Update zone, country & city",
    cityWeatherManagement: "City weather data",
    weatherProfileBaseOnCity: "Update weather profile base on city",
    ecatDataManagement: "e-CAT data management",
    digitalEcatLibrary: "Digital e-CAT Library",
    ecatLibraryEquipmentsModels: "e-CAT library equipments & models",
    cancel: "Cancel",
    save: "Save",
    permission: "Permission",
    noAccountInfo: "No account information",

    customerFeedback: "Customer feedback",
    viewFeedbackList: "Feedback information from users",

    unitSetting: "Unit setting",
    globalUnitPreferences: "Global unit preferences",

    usefulTools: "Useful tools",
    efficiency: "Efficiency"
  },
  account: {
    inputUserName: "Input E-mail",
    thereAreNoMoreUsersLeft: "There are no more users left.",
    superAdmin: "Super Administrator",
    global: "Global",
    region: "Region",
    regional: "Regional",
    zoneCountry: "Zone/Country",
    city: "City",
    segmentMegaCity: "Segment(Mega city)",
    status: "Status",
    activeStatus: "Active status",
    role: "Role",
    active: "Active",
    inactive: "Inactive",
    fillRole: "Please select a role",

    multiRegional: "Multi Regional",
    multiZoneCountry: "Multi Zone/Country",
    singleZoneCountry: "Single Zone/Country",
    otherRegions: "other regions",
    otherZones: "other zones"
  },
  feedback: {
    yourOpinionImportant: "Your opinion is important",
    tellYourExperience: "Please tell us your user experience",
    detailedFeedback: "Please enter your feedback:",
    provideDetailedYourOpinionssuggestions:
      "Bitte geben Sie eine detaillierte Beschreibung Ihrer Anmerkungen und Vorschläge. Sie können diese Seite erneut von [Mein Bereich] -> [Mein Feedback] öffnen.",
    submitFeedback: "Submit feedback",
    ifProblemsContact: "If you encounter urget problems, please contact",
    localAdministrator: "local support",
    noFeedback: "No feedback",
    submissionSuccessful: "Submission successful",
    myFeedback: "My feedback",
    thereAreNoMoreFeedbackLeft: "There are no more feedback left."
  },
  digitalEcat: {
    publicEcatLib: "e-CAT library",
    myCustomized: "Own library",
    chillerCapacity: "Chiller capacity",
    thereNoEcatLeft: "There are no more e-CAT data left",
    capacityRange: "Capacity range",
    compressorType: "Compressor type",
    refrigerantType: "Refrigerant type",
    pleaseSelectOrEnter: "Search model or select filter criteria",
    clickHereToSelectAJsonFile: "Click here to select a JSON file",
    successfullyParsed: "Successfully parsed {modelsCount} models",
    bearingType: "Bearing type",
    manufacturingRegion: "Manufacturing source",
    me: "me",
    libraryOwner: "Library owner",
    addSelfChillerModel: "Add own chiller model",
    capacity: "Capacity",
    designCondenserTemp: "Design condenser temp.",
    eCatPerformanceData: "e-CAT performance data",
    point4Data: "4-point data",
    point10Data: "10-point data",
    computerPreview: "Performance curve preview",
    previewChilledWaterTemp: "Preview chilled water supply temp.",
    previewCondenserTemp: "Preview condenser water supply temp.",
    previewCondenserAirTemp: "Preview condenser air supply temp.",
    compute: "Compute",
    chillerType: "Chiller type",
    youAreCurrentlyUsingLibrary: "You are currently using '{selectUserEmail}' library and are not allowed to modify and save it.",

    chillerModel: "Chiller model",
    modelNumber: "Model number",
    objective: "Objective",
    heatpumpType: "Heat pump type",
    heatpumpFileParsed: "Heatpump file parsed successfully",
    chillerFileParsed: "Chiller file parsed successfully",

    previewSourceWaterTemp: "Preview source water supply temp",
    previewSourceAirTemp: "Preview source air supply temp",
    previewHotWaterTemp: "Preview hot water supply temp",

    deviceType: "Device type",
    addSelfHeatPumpModel: "Add own heat pump model",
    heatPumpModel: "Heat pump model",
    selectEquipmentType: "Select equipment type",
    createACustomChillerModel: "Create a custom chiller model",
    createACustomHeatPumpModel: "Create a custom heat pump model"
  },
  usefulTools: {
    asseesConfig: "Asses the benefits of upgrading air handing unit fans to direct drive configurations.",
    clickEnter: "Click to enter",
    integratesTools: "This platform integrates all the upgrade and retrofit tools"
  }
}



// WEBPACK FOOTER //
// ./src/locale/admin/en.js